const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8081';

export class APIError extends Error {
  constructor(message, status) {
    super(message);
    this.status = status;
  }
}

export const api = async (path, options = {}, mayRefresh = true) => {
  const request = {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...options.headers },
    ...options,
  };
  let response = await fetch(`${API_BASE}${path}`, request);
  if (response.status === 401 && mayRefresh && path !== '/auth/refresh') {
    const refreshed = await fetch(`${API_BASE}/auth/refresh`, { credentials: 'include' });
    if (refreshed.ok) response = await fetch(`${API_BASE}${path}`, request);
  }
  const payload = response.status === 204 ? null : await response.json().catch(() => null);
  if (!response.ok) throw new APIError(payload?.message || `Ошибка запроса (${response.status})`, response.status);
  return payload;
};
